import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

const TicketScans = ({ ticketId, usageHistory, usesRemaining }) => (
  <div>
    <div className="d-flex justify-content-between align-items-center">
      <div className="text-grey text-xxx-small">
        TICKET {ticketId} SCAN HISTORY
      </div>
      <div className="d-flex align-items-center">
        <div className="text-xxx-small fw-bold">Uses remaining</div>
        <div className="ticket-history--uses-remaining text-x-small">
          {usesRemaining}
        </div>
      </div>
    </div>
    <div className="bg-light-subtle rounded mt-2">
      {isEmpty(usageHistory) ? (
        <div className="text-center py-3 text-grey text-xx-small">No data</div>
      ) : (
        <div className="px-3 py-1 text-x-small text-grey">
          {usageHistory.map(({ date, time }, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${date}-${time}-${index}`}
              className="d-flex ticket-history--table-line"
            >
              <div className="ticket-history--table-time">{time}</div>
              <div>{date}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default TicketScans;
TicketScans.propTypes = {
  ticketId: PropTypes.string.isRequired,
  usageHistory: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
    })
  ).isRequired,
  usesRemaining: PropTypes.number.isRequired,
};
